import { render, staticRenderFns } from "./ResellerProductForm.vue?vue&type=template&id=6c3e56b8&"
import script from "./ResellerProductForm.vue?vue&type=script&lang=js&"
export * from "./ResellerProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports